// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"133":"devise-slices","383":"devise-media","469":"devise-editors"}[chunkId] + "." + {"133":"bfc75e8b","383":"bfc75e8b","469":"bfc75e8b"}[chunkId] + ".css";
};